export enum Brand {
    NEW_WORLD = "NW",
    PAK_N_SAVE = "PNS"
}